import React, {useEffect, useState } from "react";
import "bootstrap/dist/css/bootstrap.min.css";
import { useUserProfile } from "../../contexts/UserProfileContext";
import EditProfileModal from "../../view/EditProfileModal";
import { useLocation } from 'react-router-dom';
import { WEBSITE_NAME } from '../../config/branding.js';
import logoLight from '../../assets/threadshare_logo.svg';
import logoDark from '../../assets/threadshare_logo_dark.svg';




import "../../CSS/NavBar.css"
import { Link } from "react-router-dom";
import { useNavigate } from "react-router-dom";
// import {
//   Navbar,
//   Nav,
//   Container,
//   Button,
//   Dropdown,
//   Form,
//   Modal,
//   Image
// } from "react-bootstrap";

import {
  Navbar,
  Nav,
  Container,
  Button,
  Image
} from "react-bootstrap";

import "../../CSS/NavBar.css";

// const countries = [
//   "English (United States)",
//   "Hindi (India)",
//   "Chinese (China)",
//   "Spaish (Spain)",
//   "French (France)",
// ];

const TopNavbar = () => {
  const navigate = useNavigate();
  const [showProfileModal, setShowProfileModal] = useState(false);
  const [summaryDarkMode, setSummaryDarkMode] = useState(false);
  const [logoError, setLogoError] = useState(false);
  
  // Use centralized profile context
  const { getUserData } = useUserProfile();
  const userData = getUserData();
  
  const userId = userData.id;
  const userName = userData.name;
  const userEmail = userData.email;
  const userImage = userData.image;

// Logout moved to Settings page

  
  const location = useLocation();
const currentPath = location.pathname;
console.log('Current Path:', currentPath);

  // Check if we're on a summary page and if dark mode is enabled
  const isOnSummaryPage = currentPath.startsWith('/summary/');
  
  // Listen for dark mode changes in localStorage
  useEffect(() => {
    const checkSummaryDarkMode = () => {
      const darkMode = localStorage.getItem('darkMode');
      setSummaryDarkMode(darkMode ? JSON.parse(darkMode) : false);
    };
    
    // Initial check
    checkSummaryDarkMode();
    
    // Listen for localStorage changes
    const handleStorageChange = (e) => {
      if (e.key === 'darkMode') {
        checkSummaryDarkMode();
      }
    };
    
    window.addEventListener('storage', handleStorageChange);
    
    // Also listen for manual updates (custom event)
    const handleDarkModeChange = () => {
      checkSummaryDarkMode();
    };
    
    window.addEventListener('darkModeChanged', handleDarkModeChange);
    
    return () => {
      window.removeEventListener('storage', handleStorageChange);
      window.removeEventListener('darkModeChanged', handleDarkModeChange);
    };
  }, []);
  
  
  // Check if we're on the landing page (only page where Get Started should show)
  const isOnLandingPage = currentPath === '/';
  
  // Determine if navbar should be dark (only on summary pages with dark mode enabled)
  const shouldBeDark = isOnSummaryPage && summaryDarkMode;

  // Debug: Log logo paths and environment info
  useEffect(() => {
    const logoUrl = shouldBeDark ? logoDark : logoLight;
    console.log('🎨 [TopNavbar] Logo configuration:');
    console.log('  Logo path:', logoUrl);
    console.log('  Full URL:', window.location.origin + logoUrl);
    console.log('  Current origin:', window.location.origin);
    console.log('  Current pathname:', window.location.pathname);
    console.log('  Environment:', process.env.NODE_ENV);
    console.log('  Public URL:', process.env.PUBLIC_URL || '(not set)');
    
    // Pre-check if logo file exists
    fetch(logoUrl, { method: 'HEAD' })
      .then(response => {
        console.log('✅ [TopNavbar] Logo pre-check successful:');
        console.log('  Status:', response.status);
        console.log('  Content-Type:', response.headers.get('content-type'));
        console.log('  Response URL:', response.url);
      })
      .catch(error => {
        console.warn('⚠️ [TopNavbar] Logo pre-check failed:', error);
      });
  }, [shouldBeDark]);

   
  return (
    

    <Navbar 
      bg={shouldBeDark ? "dark" : "light"} 
      expand="lg" 
      className={`py-3 ${shouldBeDark ? 'navbar-dark summary-navbar-dark' : ''}`}
      style={shouldBeDark ? {
        backgroundColor: '#2d2d2d',
        borderBottom: '1px solid #404040'
      } : {}}
    >
      <Container fluid>
        {/* Brand Logo */}
        <Navbar.Brand as={Link} to="/" className="d-flex align-items-center" style={{ textDecoration: 'none' }}>
          {!logoError ? (
            <img
              src={shouldBeDark ? logoDark : logoLight}
              alt="Logo"
              className="me-2"
              style={{ width: "80px", height: "80px", borderRadius: "50%" }}
              onLoad={() => {
                const logoUrl = shouldBeDark ? logoDark : logoLight;
                console.log('✅ Logo loaded successfully:', logoUrl);
                console.log('📍 Full URL:', window.location.origin + logoUrl);
                console.log('🌐 Current origin:', window.location.origin);
                console.log('🔍 Logo path:', logoUrl);
              }}
              onError={(e) => {
                const logoUrl = shouldBeDark ? logoDark : logoLight;
                const fullUrl = window.location.origin + logoUrl;
                console.error('❌ Logo failed to load');
                console.error('📍 Logo URL:', logoUrl);
                console.error('🌐 Full URL:', fullUrl);
                console.error('🔍 Current origin:', window.location.origin);
                console.error('📄 Current pathname:', window.location.pathname);
                console.error('🖼️ Image element:', e.target);
                console.error('📊 Image src attribute:', e.target.src);
                console.error('🔗 Image currentSrc:', e.target.currentSrc);
                
                // Try to fetch the logo to see what we get
                fetch(logoUrl, { method: 'HEAD' })
                  .then(response => {
                    console.error('📡 Logo fetch response status:', response.status);
                    console.error('📡 Logo fetch response statusText:', response.statusText);
                    console.error('📡 Logo fetch response headers:', Object.fromEntries(response.headers.entries()));
                    console.error('📡 Logo fetch response type:', response.type);
                    console.error('📡 Logo fetch response url:', response.url);
                  })
                  .catch(fetchError => {
                    console.error('📡 Logo fetch error:', fetchError);
                  });
                
                setLogoError(true);
              }}
            />
          ) : (
            <div
              className="me-2 d-flex align-items-center justify-content-center"
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "50%",
                backgroundColor: shouldBeDark ? '#667eea' : '#1DA1F2',
                color: 'white',
                fontSize: '24px',
                fontWeight: 'bold'
              }}
            >
              TS
            </div>
          )}
          <span className="custom-font">{WEBSITE_NAME}</span>
        </Navbar.Brand>

        {/* Navbar Toggler for Small Screens */}
        <Navbar.Toggle aria-controls="navbarResponsive" />

        {/* Collapsible Section */}
        <Navbar.Collapse id="navbarResponsive">
          {/* Menu Items */}
          {userId ? <Nav className="me-auto navbar-item">
            {/* <Nav.Link as={Link} to={"/"} className={currentPath === "/" ? "fw-bold" : ""}>
              Home
            </Nav.Link> */}

            <Nav.Link as={Link} to={"/dashboard"} className={currentPath === "/dashboard" ? "fw-bold" : ""}>
              Dashboard
            </Nav.Link>

            <Nav.Link as={Link} to={"/extension"} className={currentPath === "/extension" ? "fw-bold" : ""}>
              Download Extension
            </Nav.Link>

            {/* Mobile-only navigation links */}
            <Nav.Link as={Link} to={"/dashboard"} state={{ activeMenu: "Payment" }} className="d-md-none">
              Payment
            </Nav.Link>
            <Nav.Link as={Link} to={"/dashboard"} state={{ activeMenu: "Settings" }} className="d-md-none">
              Settings
            </Nav.Link>
            
            {/* Show admin link only for admin users */}
            {process.env.REACT_APP_ADMIN_EMAILS?.split(',').includes(userEmail) && (
              <Nav.Link as={Link} to={"/admin"} className={currentPath === "/admin" ? "fw-bold" : ""}>
                Admin
              </Nav.Link>
            )}
            {/* <Nav.Link as={Link} to={"/settings"} className={currentPath === "/settings" ? "fw-bold" : ""}>
              Settings
            </Nav.Link> */}
          </Nav> :<div className="spacer"></div>}
          

          {/* Right-side Buttons */}
          <div className="d-flex align-items-center">
            {/* Search Field */}
            {/* <Form className="d-flex me-3">
              <Form.Control
                type="search"
                placeholder="Search"
                className="rounded-pill search-bar"
                aria-label="Search"
                style={{ width: "200px" }}
              />
            </Form> */}

            <EditProfileModal
  show={showProfileModal}
  onHide={() => setShowProfileModal(false)}
  user={{ name: userName, email: userEmail, image: userImage || "/assets/default_user.png" }}
/>

            {/* Country Dropdown */}
            {/* <Dropdown className="me-3 custom-dropdown">
      <Dropdown.Toggle
        variant="outline-secondary"
        id="countryDropdown"
        className="custom-dropdown-toggle"
      >
        {selectedCountry}
      </Dropdown.Toggle>
      <Dropdown.Menu className="custom-dropdown-menu">
        {countries.map((country, index) => (
          <Dropdown.Item
            onClick={() => handleSelectCountry(country)}
            key={index}
            className="custom-dropdown-item"
          >
            {country}
          </Dropdown.Item>
        ))}
      </Dropdown.Menu>
    </Dropdown> */}
            {/* Buttons */}
              
{/* Get Started Button - Only show on landing page */}
            {isOnLandingPage && (
              <Button 
                variant="primary"
                className="me-3"
                onClick={() => navigate("/create")}
                style={{ 
                  borderRadius: "8px",
                  fontWeight: "500",
                  padding: "8px 16px"
                }}
              >
                Get Started
              </Button>
            )}
            
            {userId ? (<><Button variant="link" className="custom_profile_button d-flex align-items-center" onClick={() => setShowProfileModal(true)}><Image
            src={userImage || "/assets/default_user.png"}
            alt="User"
            roundedCircle
            width={40}
            height={40}
            className="me-2"
            style={{ objectFit: 'cover' }}
          />
          <span className="me-3 fw-bold">{userName || 'User'}</span></Button></>):
<div>
  {/* <Button variant="outline-dark" className="me-3 custom-login-button-font" onClick={() => navigate("/auth?type=login")}>
              Log in
            </Button>
            <Button variant="dark" className="custom-signup-button-font" onClick={() => navigate("/auth?type=signup")}>Sign up</Button> */}
            </div>}
            
          </div>
        </Navbar.Collapse>
      </Container>

    </Navbar>
  );
};

export default TopNavbar;
